const incidentTypes = (() => {
  let typeTable, typeData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function showAlreadyExistsWarning(msg, form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  // Incident Types
  //-------------------------------------------------------------------------------

  function getIncidentTypeView() {
    const frag = document.createDocumentFragment();
    
    typeTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Type'],
      endIcon: true,
    });

    const headers = typeTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addTypeBtnDiv = document.createElement('div');
    const addTypeBtn = new Button({
      text: 'ADD NEW TYPE',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(typeTable);
    if ($.session.SetupInsert) {
      addTypeBtn.button.style.float = 'right';
      addTypeBtn.renderTo(addTypeBtnDiv);
      frag.append(addTypeBtnDiv);
    }

    const tableTypeData = typeData
      .map(p => {
        return {
          values: [p.typeName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showTypePopup(p);
          },
          endIconCallback: () => handleTypeDelete(p),
        };
      });

    table.populate(typeTable, tableTypeData);
    table.sortTableByHeader(typeTable);

    addTypeBtn.onClick(e => {
      showTypePopup();
    });

    return frag;
  }

  // Incident Types
  //-------------------------------------------------------------------------------

  function showTypePopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const typeForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Type',
          id: 'cName',
          required: true,
        },
      ],
    });

    typeForm.onKeyup(() => {
      typeForm.inputs['cName'].setValidtyError('');
      typeForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(typeForm);
    });
    typeForm.onChange(event => {
      typeForm.inputs['cName'].setValidtyError('');
      typeForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(typeForm);
    });

    typeForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentTypeData', {
          id: rowData ? rowData.typeId : 0,
          typeName: formdata.cName.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentTypeDataResult;
      const newID = resp.typeId;
      if (newID == '-1') {
        showAlreadyExistsWarning('This type already exists.', typeForm);
        typeForm.buttons['submit'].toggleDisabled(true);
        typeForm.buttons['cancel'].toggleDisabled(true);
      } else {
        typeForm.clear();
        POPUP.hide(popup);
        await getTypeData();
        updateTypeTable();
      }
    });

    typeForm.onCancel(event => {
      typeForm.clear();
      typeForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    typeForm.renderTo(popup);

    POPUP.show(popup);

    typeForm.populate({
      cName: rowData ? rowData.typeName : '',
    });

    typeForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      typeForm.disableFormInputs();
    }
  }

  async function handleTypeDelete(row) {
    const rowData = typeData.find(a => a.typeId == row.typeId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This type is used somewhere else in the system. It cannot be deleted.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this type?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentTypeData', {
            token: $.session.Token,
            typeId: row.typeId,
          });

          await getTypeData();
          updateTypeTable();
        }
      });
    }
  }
  function updateTypeTable() {
    const tableTypeData = typeData
      .map(p => {
        return {
          values: [p.typeName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showTypePopup(p);
          },
          endIconCallback: () => handleTypeDelete(p),
        };
      });

    table.populate(typeTable, tableTypeData);
  }

  async function getTypeData() {
    const dataType = await _UTIL.fetchData('getIncidentType');
    typeData = dataType.getIncidentTypeResult;
  }


  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await getTypeData();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Types';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Types') {
      viewMarkup = getIncidentTypeView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
